// resources
import * as BBApi from '..';

const rootUrl: string = BBApi.host + '/oplevalt/dashboard';

export async function activeSubscriptions(dateFrom: string, dateTo: string, includeCancelled = false): Promise<number> {
	const url: URL = new URL(rootUrl + '/active-subscriptions');
	url.searchParams.append('dateFrom', dateFrom)
	url.searchParams.append('dateTo', dateTo)
	url.searchParams.append('includeCancelled', includeCancelled.toString())

	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const {subscriptionCount} = await response.json();
	return subscriptionCount;
}

export type RevenueValuesType = { subRevenue: number, experienceRevenue: number }
export async function revenue(dateFrom: string, dateTo: string, includeCurrentDate = true): Promise<RevenueValuesType> {
	const url: URL = new URL(rootUrl + '/revenue');
	url.searchParams.append('dateFrom', dateFrom)
	url.searchParams.append('dateTo', dateTo)
	url.searchParams.append('includeCurrentDate', includeCurrentDate.toString())

	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const revenue = await response.json();
	return revenue;
}

export type SalesType = { 
	firstName: string,
	city: string,
	title: string,
	price: number,
	persons: number,
	created: string
 }
export async function latestSales(): Promise<[SalesType]> {
	const url: URL = new URL(rootUrl + '/latest-sales');

	const response: Response = await BBApi.get(url.href);

	if (response.ok === false) {
		const message: string = await response.text();
		throw new Error(message);
	}

	const latestSales = await response.json();
	return latestSales;
}
